import {
  BasePaymentClient,
  Payments,
  PayWithSavedMethodInput,
  SavePaymentCardArgs,
  SavePaymentCardResponse,
  SbpPaymentArgs,
  TinkoffGetQr,
  TinkoffPayment,
  TOrder,
} from "@core/types";
import { CreateYooKassaPaymentInput } from "@core/types";
import { convertYooKassaPayloadForSupa } from "../../../../core/src/shared/client/converters";
import { SupaPayments } from "../types/supabaseFragments";
import { convertSbpPaymentToPayments } from "./converters";
import { supabaseClient } from "../supabase";

class PaymentClient extends BasePaymentClient {
  async createYooKassaPayment(createYooKassaPaymentInput: CreateYooKassaPaymentInput): Promise<any> {
    const body = convertYooKassaPayloadForSupa(createYooKassaPaymentInput);
    const response = await this.instance.post("/payments/create", body);

    return response.data;
  }

  async getYooKassaPayment(paymentId: string) {
    const response = await this.instance.get(`/payments/${paymentId}`);

    return response.data;
  }

  async payWithSavedMethod(payWithSavedMethodInput: PayWithSavedMethodInput): Promise<any> {
    const response = await this.instance.post("/payments/create-with-saved", payWithSavedMethodInput);

    return response.data;
  }

  async createPaymentTinkoffQr(orderId: TOrder["id"]): Promise<TinkoffGetQr | null> {
    throw new Error("getPaymentTinkoffQr not implemented");
  }

  async getTinkoffPayment(paymentId: TOrder["id"]): Promise<TinkoffPayment> {
    throw new Error("getTinkoffPayment not implemented");
  }

  async savePaymentCard(args: SavePaymentCardArgs): Promise<SavePaymentCardResponse> {
    const response = await this.instance.post("/payments/save-card", args);
    return response.data;
  }

  async createSBPPayment(args: SbpPaymentArgs): Promise<Payments | null> {
    const res = await supabaseClient.functions.invoke<SupaPayments>("sbp-payment", {
      body: { order_id: args.orderId, customer_id: args.customerId },
    });

    return res?.data ? convertSbpPaymentToPayments(res.data) : null;
  }
}

export default PaymentClient;
